import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const BASE_TITLE = 'CodeDesign.ai'

/**
 * Route-to-title mapping.
 * Matched top-down; first prefix match wins.
 */
const ROUTE_TITLES = [
  { path: '/ai', title: 'AI Website Builder' },
  { path: '/draft-generations', title: 'Recent AI Generations' },
  { path: '/cms', title: 'Blog CMS' },
  { path: '/projects', title: 'Projects' },
  { path: '/overview', title: 'Overview' },
  { path: '/analytics', title: 'Analytics' },
  { path: '/pages', title: 'Site Pages' },
  { path: '/components', title: 'Components' },
  { path: '/blocks', title: 'Blocks' },
  { path: '/blog', title: 'Blog' },
  { path: '/forms', title: 'Forms' },
  { path: '/contacts', title: 'Contacts' },
  { path: '/orders', title: 'Orders' },
  { path: '/products', title: 'Products' },
  { path: '/notifications', title: 'Notifications' },
  { path: '/webhooks', title: 'Webhooks' },
  { path: '/integrations', title: 'Integrations' },
  { path: '/ai-chatbot', title: 'AI Chatbot' },
  { path: '/media', title: 'Media Library' },
  { path: '/files', title: 'File Manager' },
  { path: '/domains', title: 'Domains' },
  { path: '/seo-audit', title: 'Website Analysis' },
  { path: '/profile', title: 'Profile' },
  { path: '/settings', title: 'Settings' },
  { path: '/guest-access', title: 'Guest Access' },
  { path: '/seo', title: 'SEO' },
  { path: '/site-speed', title: 'Site Speed' },
  { path: '/wordpress', title: 'WordPress' },
  { path: '/domain', title: 'Domains' },
  { path: '/team', title: 'Team' },
  { path: '/teams', title: 'Team' },
  { path: '/social-media', title: 'Social Media' },
  { path: '/project-management', title: 'Tasks' },
  { path: '/image-generation', title: 'AI Images' },
  { path: '/form-builder', title: 'Form Builder' },
  { path: '/usage', title: 'Usage' },
  { path: '/billing', title: 'Billing' },
  { path: '/pricing', title: 'Pricing' },
  { path: '/shared-projects', title: 'Shared Projects' },
  { path: '/invite', title: 'Invitation' },
]

function getTitleForPath(pathname) {
  if (pathname === '/') {
    return `Home | ${BASE_TITLE}`
  }

  const match = ROUTE_TITLES.find(route => pathname.startsWith(route.path))
  if (match) {
    return `${match.title} | ${BASE_TITLE}`
  }
  return `Dashboard | ${BASE_TITLE}`
}

/**
 * Dynamically sets document.title based on the current route.
 * Drop this into a top-level component (e.g. AppShell) — no props needed.
 */
export default function usePageTitle() {
  const { pathname } = useLocation()

  useEffect(() => {
    document.title = getTitleForPath(pathname)
  }, [pathname])
}
